import {Injectable} from '@angular/core';
import {AdapterInterface} from '../adapter.interface';

export class ErrorMessage {
    constructor(
        public messageCode: string,
        public parameters: string[],
    ) {}
}

@Injectable({
    providedIn: 'root'
})

export class ErrorMessageAdapter implements AdapterInterface<ErrorMessage> {
    adapt(item: any): ErrorMessage {
        return new ErrorMessage(
            item.messageCode,
            item.parameters,
        );
    }
}
